<template>
  <div>
    <!-- Your Vue component content here -->

    <div id="global-loader" ref="globalLoader">
      <div class="loader-img">
        <img src="@/assets/img/loader.png" class="img-fluid" alt="Global">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.hideGlobalLoader();
  },
  methods: {
    hideGlobalLoader() {
      setTimeout(() => {
        const globalLoader = this.$refs.globalLoader;

        setTimeout(() => {
          globalLoader.style.opacity = "0";
          globalLoader.style.transition = "opacity 0.5s ease";

          setTimeout(() => {
            globalLoader.style.display = "none";
          }, 500);
        }, 100);
      }, 500);
    }
  }
};
</script>
